.underlined {
  text-decoration: underline;
}
